import * as React from 'react'
import ASK1 from './images/akc1.png';
import ASK2 from './images/AKC2.png';
import ASK3 from './images/AKC3.png';
import ASK4 from './images/AkC4.png';
import Whirligig from 'react-whirligig';
import './css/ExploreAskSlider.scss';
import {
    isMobileOnly,
    isTablet
} from "react-device-detect";

const ExploreAskSlider = () => {

    let height,imageHeight,visibleSlides;

    if(isMobileOnly){
        height="170px";
        imageHeight="340px";
        visibleSlides=1.3;
    }
    else if(isTablet){
        height="350px";
        imageHeight="300px";
        visibleSlides=1.3;
    }

    return (
        <div className="container ExploreAskSlider">
            <h1 className="Explore-ASKADEMIA">Explore ASKADEMIA</h1>
            <div>
                <Whirligig
                    slideBy={1}
                    visibleSlides={visibleSlides}
                >
                    <div className="card coloumn mb-4">
                        <img src={ASK1} alt="ASK1" style={{ width:"100%",height:height,objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body Rectangle-78">
                            <h5 className="card-title title">Tutoring</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img src={ASK2} alt="ASK2" style={{ width:"100%",height:height,objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body Rectangle-78">
                            <h5 className="card-title title">Study Centres</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img src={ASK3} alt="ASK3" style={{ width:"100%",height:height,objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body  Rectangle-78">
                            <h5 className="card-title title">Blogs</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                </Whirligig>
            </div>
            <div className="col-12 p-0">
                <div style={{marginTop:"101px",marginBottom:"97px",backgroundColor:"black",overflow:"hidden"}}>
                <img src={ASK4} alt="ASK4" style={{height:imageHeight,width:'100%',opacity:0.35,objectFit:"cover"}}></img>
                <div className="imgText">
                    <div className="Online-tutoring-jobs">Online tutoring jobs</div>
                    <div className="A-selection-of-job-tailored-and-verified-for-you">A selection of job tailored and verified for you</div>
                    <div className="Find-a-tutor-in-any-subject-to-help-you-learn-a-virtual-classroom">Find a tutor in any subject to help you learn a virtual classroom</div>
                    <button className="Rectangle-95">Find Jobs &gt;</button>
                </div>
                </div>
            </div>
        </div>
    )
}

export default ExploreAskSlider;